import { Value } from 'app/types-shared';
import { LinkCodesActionType } from './constants';
import { ActionPayloadType } from './types-store';

interface LinkCodesValue extends Value {
  disabled: string;
}

export interface CodeFieldWire {
  id: number;
  label: string;
  searchRequired: boolean;
}

export interface CodetableMetadataWire {
  hierarchy: boolean;
  category: CodeFieldWire;
  class: CodeFieldWire;
}

export interface ListBranchItemWire {
  code: Value;
  node: LinkCodesValue;
  descendantCount: number;
  icon?: string;
  decimalColour?: number;
  disabled: string;
  subset: Value[];
  application: Value[];
  class: Value[];
}

export interface ListBranchWire {
  totalNumberOfResults: number;
  results: ListBranchItemWire[];
}

export interface LinkCodesActionWire {
  codeId: number;
  applyOnDescendants: boolean;
  action: LinkCodesActionType;
}

export interface LinkCodesPayload {
  type: ActionPayloadType;
  id: number;
}

export interface GroupedError {
  message: string;
  descriptions: string[];
}

export interface RowSelection {
  path: number[];
  append: boolean;
  range: boolean;
}

export enum CodeFieldWireKey {
  code = 'code',
  userGroup = 'subset',
  caseType = 'application',
  type = 'class',
  colour = 'colour',
  icon = 'icon'
}
